<template>
  <div v-show="visible" :class="_.button" @click="handleClick">
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { bindEvent, throttle } from 'vtils'

  export default Vue.extend({
    data: () => ({
      visible: false,
    }),

    mounted() {
      this.apply()
    },

    beforeDestroy() {
      this.apply(true)
    },

    activated() {
      this.apply()
    },

    deactivated() {
      this.apply(true)
    },

    methods: {
      handleScroll: throttle(function () {
        this.visible =
          document.querySelector('.__page_container__').scrollTop > 100
      }, 60),

      apply(destroy = false) {
        this._unbind?.()
        if (!destroy) {
          this.$nextTick(() => {
            const el = document.querySelector('.__page_container__')
            this._unbind = bindEvent(el)('scroll', this.handleScroll.bind(this))
          })
        }
      },

      handleClick() {
        document.querySelector('.__page_container__').scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .button {
    position: fixed;
    display: flex;

    &:active {
      opacity: 0.8;
    }
  }
</style>
